import React from 'react';
import axios from 'axios';
import {  Modal } from 'semantic-ui-react'

export default class Passed extends React.Component {

async componentDidMount() {
    console.log("mounted pass", this.props.individualTests)
    var date = new Date()
    var year = date.getFullYear()
    document.cookie = 'hasPassed=true;expires=Thu, 18 Dec '+ (year + 1) +' 12:00:00 UTC;'
    let user = this.props.getCookie('loggedInUser')
    let userID = this.props.getCookie('loggedInId')
    var timings
    await axios.get('/api/getTimings', {
      params: {
        userID: userID
      }
    })
    .then(function(res, err) {
      timings = res.data
    }) 
    await axios.get('/api/userPassed', {
      params: {
        email_addr: user,
        finalTest: this.props.failedFinalTest,
        testStats: this.props.individualTests,
        timings: timings
      }
    })
    .then(function(res, err) {
      console.log(res)
    })
  }

  render () {
  return (
    <div style={{overflowY: 'auto'}}>
    	Congragulations! You have successfully completed the potential products training. You can now log in to the site http://internal.gsmsaleskc.com.
    	Navigate to Process 3.0 --> Potential Products Aggregation and begin inputting live data. You will also be sent an invite (via email) to our Ryver channel
    	where we manage team information.

      <Modal
        defaultOpen
        header='Hey!'
        content="You have successfully completed the training program! In order to begin working with live data, 
            please click on the following page to login using the email address you previously registered with and a default password of 'password'. 
            Once logged in, you can change your password to something else if you'd like by clicking on your Profile icon > Change Password in the top 
            right corner of the screen. Welcome aboard the team!"
        actions={[
          { key: 'done', content: 'Okay!', positive: true },
        ]}
      />
    </div>
  	)
	}
}


// WEBPACK FOOTER //
// ./src/components/Passed.js